import createIcon from '../../createIcon';

/**
 * @component @name Redo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNjI5NSAxMS4xQzE2Ljc3OTUgOS40OSAxNC4zNzk1IDguNSAxMS43Mjk1IDguNUM3LjA3OTUzIDguNSAzLjE0OTUzIDExLjUzIDEuNzY5NTMgMTUuNzJMNC4xMjk1MyAxNi41QzUuMTc5NTMgMTMuMzEgOC4xNzk1MyAxMSAxMS43Mjk1IDExQzEzLjY3OTUgMTEgMTUuNDU5NSAxMS43MiAxNi44NDk1IDEyLjg4TDEzLjIyOTUgMTYuNUgyMi4yMjk1VjcuNUwxOC42Mjk1IDExLjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Redo = createIcon('Redo', [
  [
    'path',
    {
      d: 'M18.6295 11.1C16.7795 9.49 14.3795 8.5 11.7295 8.5C7.07953 8.5 3.14953 11.53 1.76953 15.72L4.12953 16.5C5.17953 13.31 8.17953 11 11.7295 11C13.6795 11 15.4595 11.72 16.8495 12.88L13.2295 16.5H22.2295V7.5L18.6295 11.1Z',
      key: 'chp1uk',
    },
  ],
]);

export default Redo;
